/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {validateEmailAddress} from '../api'

export const useMutationValidateEmailAddress = createReactQueryMutationHook('validateEmailAddress', validateEmailAddress)
